import './full-img.scss';

import React from 'react';

import scrollEvents from '../lib/scroll-events';

class FullImg extends React.Component {
  componentDidMount(){
    //   scrollEvents.add({
    //     triggerSelector: '.full-img',
    //     offset: '-50vh',
    //     targets: [
    //     {
    //       targetSelector: '.img',
    //       events: {
    //         onTick: (el, dir, prog) => {
    //           el.style.transform = `translateY(-${50*prog}px)`;
    //         }
    //       }
    //     },
    //     {
    //       targetSelector: '.bg',
    //       events: {
    //         onTick: (el, dir, prog) => {
    //           el.style.transform = `translateY(${75*prog}px)`;
    //         }
    //       }
    //     }
    //   ]
    // })
  }

  render(){
    let { src, children } = this.props;
    return (
      <div className='full-img' style={{
        height: '530px',
        marginBottom: '150px',
        position: 'relative'
      }}>
        <div className='bg' style={{
          position: 'absolute',
          top: 0,
          left: 0,
          width: '100%',
          height: '100%',
          background: 'url("/static/images/hatch-bg.png")',
          zIndex: 0,
          opacity: 1
        }}>
          <div style={{
            background: '#A05925',
            width: '100%',
            height: '100%',
            opacity: 0.9
          }}/>
        </div>
        <div className='row' style={{
          position: 'relative',
          display: 'block',
          top: '75px',
          width: '80%',
          overflow: 'hidden',
          height: '100%',
          margin: '0 auto'
        }}>
          {children}
        </div>
      </div>
    );
  }
}

export default FullImg;



// WEBPACK FOOTER //
// ./src/components/full-img.js